export interface ProgramMassiveUpload {
    id: number;
    fileName: string;
    programs: number;
    lines: number;
    programsProcessed: number;
    linesProcessed: number;
    errorMessage?: string | null;
    status: ImportProcessStatus;
    profileId: number;
}

export enum ImportProcessStatus {
    Pending = 1,
    Processing = 2,
    Completed = 3,
    Error = 4,
    CompletedWithErrors = 5
}
